function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* tslint:disable no-empty */
import { ServiceErrorType, ServiceMeta } from '@central-products/transport-bus-common';
import { addListener, getListeners, removeListener } from './bindings/eventListeners';
import { bindService, getServiceBinding, unbindService } from './bindings/serviceBindings';
import { getBoundToAnotherInstanceErrorMsg, getNotInterfaceErrorMsg, getUnknownServiceErrorMsg, getUnknownServiceMethodErrorMsg } from './errorMessages';
import { callToValidRequest, responseToValidResult } from './utils';
export var AbstractTransport =
/*#__PURE__*/
function () {
  function AbstractTransport() {
    _classCallCheck(this, AbstractTransport);
  }

  _createClass(AbstractTransport, [{
    key: "get",
    // tslint:disable-next-line:callable-types
    value: function get(ServiceClass) {
      var _this = this;

      var meta = ServiceMeta.getOrThrow(ServiceClass.prototype, getNotInterfaceErrorMsg(ServiceClass.name));
      var service = new ServiceClass();
      meta.validate(service);
      var domain = meta.domain,
          serviceName = meta.serviceName;
      meta.methods.forEach(function (m) {
        service[m.property] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var methodArgs = callToValidRequest(m, domain, serviceName, args);
          return _this.callMethod(methodArgs).then(function (data) {
            return responseToValidResult(m, domain, serviceName, data);
          });
        };
      });
      meta.events.forEach(function (e) {
        service[e.property] = function (callback) {
          return _this.addEventListener(meta, e, callback);
        };
      });
      return service;
    }
  }, {
    key: "bind",
    value: function bind(service) {
      var meta = ServiceMeta.getOrThrow(service, getNotInterfaceErrorMsg(service.constructor.name));
      meta.validate(service);
      bindService(_objectSpread({
        implementation: service
      }, meta));
      this.bindEvents(service, meta);
      this.onBind(meta);
    }
  }, {
    key: "unbind",
    value: function unbind(intfImpl) {
      var meta = ServiceMeta.getOrThrow(intfImpl, getNotInterfaceErrorMsg(intfImpl.constructor.name));
      var binding = getServiceBinding(meta);

      if (binding) {
        var implementation = binding.implementation;

        if (implementation && implementation !== intfImpl) {
          throw new Error(getBoundToAnotherInstanceErrorMsg(meta.serviceName));
        }

        unbindService(meta);
        this.onUnbind(meta);
      }
    }
  }, {
    key: "notifySubscribers",
    value: function notifySubscribers(event) {
      var domain = event.domain,
          serviceName = event.serviceName,
          name = event.name,
          payload = event.payload;
      var eventListeners = getListeners({
        domain: domain,
        serviceName: serviceName,
        eventName: name
      });
      eventListeners.forEach(function (callback) {
        try {
          callback(payload);
        } catch (e) {
          console.error(e);
        }
      });
    }
  }, {
    key: "callMethod",
    value: function callMethod(data) {
      var domain = data.domain,
          serviceName = data.serviceName,
          name = data.name;
      var binding = getServiceBinding({
        domain: domain,
        serviceName: serviceName
      });

      if (!binding || !binding.implementation) {
        return Promise.reject(_objectSpread({}, data, {
          payload: {
            error: ServiceErrorType.ServiceUnknown,
            message: getUnknownServiceErrorMsg(serviceName)
          }
        }));
      }

      var method = binding.methods.get(name);

      if (!method) {
        return Promise.reject(_objectSpread({}, data, {
          payload: {
            error: ServiceErrorType.ServiceUnknown,
            message: getUnknownServiceMethodErrorMsg(serviceName, name)
          }
        }));
      }

      return method(data);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents(intfImpl, meta) {
      var _this2 = this;

      var domain = meta.domain,
          serviceName = meta.serviceName,
          events = meta.events;
      events.forEach(function (_ref) {
        var name = _ref.name,
            property = _ref.property;
        intfImpl[property](function (newState) {
          _this2.notifySubscribers({
            domain: domain,
            serviceName: serviceName,
            name: name,
            payload: newState
          });
        });
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(serviceMeta, eventMeta, callback) {
      var _this3 = this;

      var domain = serviceMeta.domain,
          serviceName = serviceMeta.serviceName;
      var name = eventMeta.name;
      var eventListenerData = {
        domain: domain,
        serviceName: serviceName,
        eventName: name,
        listener: callback
      };
      addListener(eventListenerData);
      this.onEventListenerAdded(domain, serviceName, name);
      return function () {
        removeListener(eventListenerData);

        _this3.onEventListenerRemoved(domain, serviceName, name);
      };
    }
  }], [{
    key: "createInstance",
    // tslint:disable-next-line:callable-types
    value: function createInstance(TransportClass) {
      if (this.transport && !(this.transport instanceof TransportClass)) {
        throw new Error('Attempt to create multiple instances of Transport');
      }

      if (this.transport) {
        console.warn('Transport instance already been created');
      }

      this.transport = new TransportClass();
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      if (!this.transport) {
        throw new Error('There is no transport');
      }

      return this.transport;
    }
  }]);

  return AbstractTransport;
}();
AbstractTransport.transport = void 0;
//# sourceMappingURL=AbstractTransport.js.map